import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {ObjectFactory} from "@commons/types";
import {cloneDeep, merge} from "lodash";
import {CoppiaTimbrature} from "@commons/mapping/CoppiaTimbrature";

export interface PresenzePianificazioneRecord extends URIAndTrace {
    idAziendaMaster: number, // Id azienda master
    idAzienda: number | null, // Id azienda
    idDip: number,
    codiceFiscale: string | null,
    quantita: number,
    dtGiornata: string,
    giornataIntera: boolean,
    oraInizio?: string,
    oraFine?: string,
}

export class PresenzePianificazioneRecord {
    static maxNumVoci = 10; // N.B. il database non prevede un limite massimo di voci di pianificazione

    static factory: ObjectFactory<PresenzePianificazioneRecord> = (json?) => {
        return merge<PresenzePianificazioneRecord, Partial<PresenzePianificazioneRecord> | undefined>(
            PresenzePianificazioneRecord.getInstance()
            , json);
    }

    static getInstance = (): PresenzePianificazioneRecord => {
        return {
            idAziendaMaster: 0,
            idAzienda: null, // N.B. deve essere null, altrimenti non verrà correttamente validato (in alternativa occorre validare >0)
            idDip: 0,
            codiceFiscale: null,
            quantita: 0,
            dtGiornata: '',
            giornataIntera: false,
            oraInizio: '',
            oraFine: '',
            URI: null,
        };
    }

    static getFilledInstance = (lavoratore: LavoratoreBase, day: PresenzeGiornataPlusRecord, user?: UserCRUDRecord) => {
        const resource = PresenzePianificazioneRecord.getInstance();
        resource.idDip = lavoratore.id;
        //resource.idAzienda = lavoratore.idAzienda;
        resource.idAziendaMaster = lavoratore.idAziendaMaster;
        resource.codiceFiscale = lavoratore.codiceFiscale;

        resource.dtGiornata = day.dtGiornata!;

        return resource;
    }

    /*static isDeleted = function (presenzeCausale: PresenzePianificazioneRecord) {
        return Workflow.isDeleted(presenzeCausale.wf);
    };

    static getDeleteTrace = function (presenzeCausale: PresenzePianificazioneRecord) {
        return presenzeCausale.wf.deleteTrace;
    };*/

    static getIntervallo(voce: PresenzePianificazioneRecord, day: PresenzeGiornataPlusRecord): CoppiaTimbrature[] {
        if (voce.giornataIntera) {
            return (day.previste && day.previste.length > 0) ? cloneDeep(day.previste).filter(coppia => !CoppiaTimbrature.isNull(coppia)) : [];
        } else if (parseInt(voce.oraInizio || '0') !== 0 || parseInt(voce.oraFine || '0') !== 0) {
            const coppia = CoppiaTimbrature.factory({entrata: voce.oraInizio, uscita: voce.oraFine});
            return [coppia];
        } else return []
    }
}